<template>
  <div>
    <div id="home" v-if="type == 0" v-loading="loading">
      <div style="height:calc(100vh - 168px);overflow-y: auto;">
        <img style="width: 18vw;margin:20px 0;" src="../assets/imgs/money.png" />
        <h1>예상 퇴직금은<br/><span style="color: #3F6DFF;">{{formatNumber(money)}}원</span></h1>
        <div class="border">
          <div>
            입사일
            <b>{{moment(joinDate).format('YYYY-MM-DD')}}</b>
          </div>
          <div>
            퇴사일
            <b>{{moment(leaveDate).format('YYYY-MM-DD')}}</b>
          </div>
          <div>
            총임금(3개월)
            <b>{{formatNumber(salary)}}원</b>
          </div>
        </div>
        <div style="font-size: 16px;margin-top: 50px;color:#717B85;">
          <div>- 출퇴근 시간이 정해져 있나요?</div>
          <div>- 정착지원금 등 고정비를 받고 있나요?</div>
          <div>- 미용실 장비, 제품 등을 지원 받았나요?</div>
          <div>- 위 조건에 해당한다면, 3.3% 프리랜서 계약서와 상관없이 퇴직금을 받을 확률이 높습니다.</div>
        </div>
      </div>
      <div class="btn" @click="go_kakao_login()">
        <img src="../assets/imgs/kakao.png"/>
        카카오 1초만에 받기 시작
      </div>
      <div class="skip" @click="go_phoneverify()">
        건너뛰기
      </div>
    </div>
    <div id="home2" v-if="type == 1">
      <img style="width: 30vw;margin:20px 0;" src="../assets/imgs/harm.png" />
      <h1>김프리님의 카카오톡으로<br/>계약서 서명 링크를 보냈습니다</h1>
      <p style="color: #717B85;margin-top: 10px;">카카오톡 메시지를 확인하고,<br/>링크를 클릭하여 서명을 완료해 주세요.</p>
      <div class="btn" @click="goHome">
        확인
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue';
  import { mapGetters, mapActions } from 'vuex'
  import moment from 'moment/moment';
  import { postAction } from '@/network/manage';
  export default {
    name: 'Result',
    components: {

    },
    data() {
      return {
        loading:false,
        type:0,
        joinDate:'',
        leaveDate:'',
        salary:'',
        money:0
      }
    },
    created(){
      if(Vue.ls.get('joinDate') && Vue.ls.get('leaveDate') && Vue.ls.get('salary') && Vue.ls.get('money')){
        this.joinDate = Vue.ls.get('joinDate')
        this.leaveDate = Vue.ls.get('leaveDate')
        this.salary = Vue.ls.get('salary')
        this.money = Vue.ls.get('money')
      }else{
        this.$router.push('/home')
      }
    },
    methods:{
      moment,
      formatNumber(value) {
        return value.toString().replaceAll(',','').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      },
      go_phoneverify() {
        this.$router.push('/phoneValidate')
      },
      goHome(){
        this.$router.push('/')
      },
      go_kakao_login(){
        window.location.href = `https://kauth.kakao.com/oauth/authorize?client_id=${process.env.VUE_APP_KAKAO_CLIENT_ID}&redirect_uri=` + process.env.VUE_APP_KAKAO_REDIRECT_URI + `&response_type=code`
      },
    }
  }
</script>

<style scoped>
  *{font-size:16px;font-size:inherit;box-sizing: border-box;margin:0px;padding:0px;}
  #home{height: 100vh;display: flex;flex-direction: column;width: 100%;padding:20px;}
  #home2{height:calc(100vh - 92px);display: flex;flex-direction: column;width: 100%;padding:20px;justify-content: center;align-items: center;text-align: center;}
  h1{color:#333333;font-size: 24px;}
  .btn{font-size: 16px;background:#FFDE33;display: flex;position: fixed;bottom:60px;justify-content: center;align-items: center;width: calc(100vw - 40px);height: 52px;border-radius: 26px;font-weight: bold;}
  .btn img{width: 22px;margin-right: 10px;}
  .skip {display: flex;position: fixed;bottom:20px;justify-content: center;align-items: center;width: calc(100vw - 40px);color:#a1a1a1;font-size: 14px;}
  .border{border:1px solid #DDDDDD;padding:20px;border-radius: 20px;margin-top: 20px;display: grid;grid-template-columns: 1fr; gap: 10px;}
  .border div{display: flex;align-items: center;justify-content: space-between;color: #717B85;}
  .border b{color:#333333;}
</style>
